export default {
  getLoggedIn: state => state.LoggedIn,
  getUrlTo: state => state.urlTo
};
